var React = require('react');

function MyProfileMyPoliciesIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","style":{"fill":"none"},"key":0}),React.createElement("path",{"id":"wallet","d":"M16.8,5.5H4.7c-.6,0-1.3-.3-1.7-.8.4-.5,1-.8,1.7-.8h13.6c.4,0,.8-.3.8-.8,0-.4-.3-.8-.8-.8H4.7c-2.1,0-3.8,1.7-3.8,3.8v7.5c0,2.1,1.7,3.8,3.8,3.8h12.1c1.2,0,2.3-1,2.3-2.3h0v-7.5c0-1.2-1-2.3-2.3-2.3h0ZM17.5,15.3c0,.4-.3.8-.8.8H4.7c-1.2,0-2.3-1-2.3-2.3v-7.5c.7.5,1.4.8,2.3.8h12.1c.4,0,.8.3.8.8v7.5ZM16,11.5c0,.4-.3.8-.8.8-.4,0-.8-.3-.8-.8,0-.4.3-.8.8-.8.4,0,.8.3.8.8,0,0,0,0,0,0h0Z","style":{"fill":"#5b6070"},"key":1})]);
}

MyProfileMyPoliciesIcon.defaultProps = {"id":"Layer_1","width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = MyProfileMyPoliciesIcon;

MyProfileMyPoliciesIcon.default = MyProfileMyPoliciesIcon;
